<template>
  <div>
    <v-card
      :style="
        `
      border: ${border_px}px solid ${border_color};
                  `
      "
      flat
      tile
      :color="bgcolor"
    >
      <v-card-text>
        <v-text-field
          v-model="ans"
          :rules="[$store.getters.NumberRule(ans)]"
          label="ตัวเลข"
          :color="color"
          style="font-size: 18px;"
          @keyup.enter="EnterSend"
          v-show="false"
        ></v-text-field>
        <v-text-field
          v-model="ans"
          :rules="[$store.getters.NumberRule(ans)]"
          label="ตัวเลข"
          :color="color"
          style="font-size: 18px;"
          @keyup.enter="EnterSend"
        ></v-text-field>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "bgcolor",
    "color",
    "color_text",
    "border_px",
    "border_color",
  ],
  data() {
    return {
      ans: null,
    };
  },
  watch: {
    ans() {
      this.$emit("Answer", +this.ans);
    },
  },
  methods: {
    EnterSend() {
      this.$emit("SendByEnter");
    },
    setAns(ans) {
      this.ans = ans;
    },
  },
};
</script>

<style lang="scss" scoped></style>
